import Helpers from './../helpers/utility';
import formatDynamic from './format-dynamic';
import StringHelpers from './helpers';
var getFormatData = StringHelpers.getFormatData, pattern = StringHelpers.pattern;
var isObject = Helpers.isObject;
/**
 * Format a template using positional arguments, an object map with named arguments, or
 * a function to dynamically inject the formatted string
 *
 *     format('Name: {0} {1}', first, last)
 *     format('Name: {first} {last}', { first: 'foo', last: 'bar'})
 *     format('name: {0} {1}', (parm, index)=>index===0 ? 'foo' : 'bar')
 *
 * @export
 * @param {string} template The template
 * @param {string | FormatProvider | Object} formats One or more arguments to use in formatting the string
 * @param {args} args Additional string arguments
 * @returns {string} The formatted string
 */
export default function format(template, formats) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (arguments.length === 2 && isFunction(arguments[1])) {
        return formatDynamic.apply(null, arguments);
    }
    var fmtData = getFormatData.apply(null, arguments);
    var index = -1;
    return (template || '').replace(pattern, function (match, parm) {
        index++;
        // if paramater has been identified by either an ordinal or a name that matches a
        // key from the object passed in, use it, otherwise match by left-to-right ordinal
        // position of parameters
        return typeof fmtData.map[parm] !== 'undefined' ?
            fmtData.map[parm] :
            index < fmtData.map.length ?
                fmtData.map[index] : match;
    });
}
function isFunction(obj) {
    return typeof obj === 'function';
}
//# sourceMappingURL=format.js.map